import { ImSpinner2 } from "react-icons/im"
import { SettingsItem } from "~/components/settings-item"

interface Props {
  className?: string
}

export function SettingsItemSkeleton({ className }: Props) {
  return <SettingsItem text="Загрузка..." icon={<ImSpinner2 className="animate-spin" />} right="" className={className} />
}
